<ms-tree-event-name [event]="event" />
<div class="tree-event-info" [class.live-event]="event.live && showBetBuilderIcon">
    @if (showInlineFavoriteToggle) {
        <ms-favourite-event-toggle [event]="event" />
    }
    @if (event.scoreboard?.started) {
        <div class="live-lap">
            <i class="live-icon">
                <span class="show-live-text">{{ sitecore.event.Live }}</span>
            </i>
            @if (showRaceInfo()) {
                <ms-tree-race-info [event]="event" />
            }
        </div>
    }
    @if (event.stream) {
        <vn-icon
            name="sports-video-badge-b"
            class="video-icon video-badge-b-icon"
            [class.video-icon-live]="event.live"
            [width]="size.width"
            [height]="size.height" />
    }
    <ms-event-timer class="tree-event-timer" [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
    @if (!!liveEventInfo) {
        <span class="live-event-info">{{ liveEventInfo }}</span>
    }
    @if (showBetBuilderIcon) {
        <span class="bet-builder-icon">
            {{ sitecore.globalMessages.BetBuilderBadgeText }}
        </span>
    }
    @if (broadcaster$ | async; as broadcaster) {
        <span class="broadcast-info"><span class="dot">•</span>{{ broadcaster }} </span>
    }
    @if (crmPromoted) {
        <ms-promotion-badge />
    }
</div>
